import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AttendanceStatisticsComponent } from './rating-statistics.component';
import { IonicModule } from '@ionic/angular';
import { TranslationModule } from '@app/app-translation.module';
import { RatingsCountStatisticComponentModule } from '../ratings-count-statistic-component/ratings-count-statistic.component.module';
import { StatisticFilterComponentModule } from '@internal-components/statistic-components/statistic-filter-component/statistic-filter.component.module';
import { RatingsAverageStatisticComponentModule } from '../ratings-average-statistic-component/ratings-average-statistic.component.module';
import { RatingsScoreStatisticComponentModule } from '../ratings-score-statistic-component/ratings-score-statistic.component.module';

@NgModule({
	declarations: [AttendanceStatisticsComponent],
	exports: [AttendanceStatisticsComponent],
	imports: [
		CommonModule,
		IonicModule,
		TranslationModule,
		StatisticFilterComponentModule,
		RatingsCountStatisticComponentModule,
		RatingsAverageStatisticComponentModule,
		RatingsScoreStatisticComponentModule,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RatingStatisticsComponentModule {}
